// 機能紹介の画像は自前サーバーにファイル名だけで配置する想定。
// data には「ファイル名だけ」を保存し、ここで base URL を前置して解決する。
// エスケープ: http(s):// 始まり or "/" 始まりはそのまま使う（既存の /image/... や外部URLを壊さない）。
const HOME_FEATURE_IMAGE_BASE = 'https://plsdb.com/image/top/';

export function resolveFeatureImage(image?: string): string | undefined {
  const v = (image || '').trim();
  if (!v) return undefined;
  if (/^https?:\/\//i.test(v) || v.startsWith('/')) return v;
  return HOME_FEATURE_IMAGE_BASE + v;
}
